(() => {
  if (window.JackRackBuilderInitialized) return;
  window.JackRackBuilderInitialized = true;

  const PLACEHOLDER_IMAGE =
    'data:image/svg+xml;charset=UTF-8,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800"><rect width="800" height="800" fill="#f2f4f7"/><path d="M232 530l119-146 88 109 60-73 116 110H232z" fill="#c8d0da"/><circle cx="310" cy="290" r="52" fill="#c8d0da"/><text x="50%" y="92%" text-anchor="middle" font-family="Arial, sans-serif" font-size="34" font-weight="700" fill="#667085">No image</text></svg>'
    );

  class JackRackBuilder {
    constructor(root) {
      this.root = root;
      this.overlay = root.querySelector('[data-jrb-overlay]');
      this.body = root.querySelector('[data-jrb-body]');
      this.scrollArea = root.querySelector('[data-jrb-scroll-area]');
      this.progressFill = root.querySelector('[data-jrb-progress-fill]');
      this.progressMarkers = root.querySelector('[data-jrb-goal-markers]');
      this.previewShellPlaceholder = root.querySelector('[data-jrb-preview-shell-placeholder]');
      this.previewShell = root.querySelector('[data-jrb-preview-shell]');
      this.previewGrill = root.querySelector('[data-jrb-preview-grill]');
      this.shellSelectorGroup = root.querySelector('[data-jrb-shell-selector-group]');
      this.shellSelector = root.querySelector('[data-jrb-shell-selector]');
      this.grillSelectorGroup = root.querySelector('[data-jrb-grill-selector-group]');
      this.grillSelector = root.querySelector('[data-jrb-grill-selector]');
      this.previewKeys = [
        root.querySelector('[data-jrb-key-1]'),
        root.querySelector('[data-jrb-key-2]'),
        root.querySelector('[data-jrb-key-3]'),
        root.querySelector('[data-jrb-key-4]')
      ];
      this.summary = root.querySelector('[data-jrb-summary]');
      this.launcherButton = root.querySelector('[data-jrb-open]');
      this.actions = root.querySelector('.jrb-actions');
      this.footer = root.querySelector('.jrb-modal__footer');
      this.prevButton = root.querySelector('[data-jrb-prev]');
      this.nextButton = root.querySelector('[data-jrb-next]');
      this.kicker = root.querySelector('[data-jrb-step-kicker]');
      this.goalTiers = root.querySelector('[data-jrb-goal-tiers]');
      this.goalTotal = root.querySelector('[data-jrb-total]');
      this.goalHint = root.querySelector('[data-jrb-goal-hint]');
      this.mobileGoalHint = root.querySelector('[data-jrb-mobile-goal-hint]');
      this.mobileGoalTotal = root.querySelector('[data-jrb-mobile-total]');
      this.mobileGoalRail = root.querySelector('[data-jrb-mobile-rail]');
      this.mobileGoalFill = root.querySelector('[data-jrb-mobile-fill]');
      this.mobileGoalDots = Array.from(root.querySelectorAll('[data-jrb-mobile-dot]'));
      this.configNode = root.querySelector('[data-jrb-config]');
      this.config = this.readConfig();

      this.previewStage = root.querySelector('.jrb-preview__stage');
      this.bgLayer = root.querySelector('[data-jrb-bg-layer]');
      this.bgImage = root.querySelector('[data-jrb-bg-image]');
      this.bgDots = root.querySelector('[data-jrb-bg-dots]');
      this.previewWrap = root.querySelector('[data-jrb-preview]');
      this.previewCoach = root.querySelector('[data-jrb-preview-coach]');
      this.previewCoachTag = root.querySelector('[data-jrb-preview-coach-tag]');
      this.previewCoachTimer = null;
      this.previewCoachActive = null;
      this.previewCoachSeen = { stage: false, shell: false, grill: false };
      this.cartSubtotalCents = Number(this.config?.cartSubtotalCents || 0);

      this.backgrounds = [
        {
          id: 'plain-white',
          image: null,
          color: '#ffffff'
        },
        {
          id: 'bg-1',
          image: 'https://cdn.shopify.com/s/files/1/0977/8868/files/2.jpg?v=1776219777'
        },
        {
          id: 'bg-2',
          image: 'https://cdn.shopify.com/s/files/1/0977/8868/files/BG1.jpg?v=1776219397'
        },
        {
          id: 'bg-3',
          image: 'https://cdn.shopify.com/s/files/1/0977/8868/files/4.jpg?v=1776219777'
        },
        {
          id: 'bg-4',
          image: 'https://cdn.shopify.com/s/files/1/0977/8868/files/5.jpg?v=1776219962'
        }
      ];

      this.currentBackgroundIndex = 0;
      this.previewKeyStartIndex = 0;
      this.activeUpsellCollectionHandle = null;

      this.bgTouch = {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        dragging: false,
        lockedAxis: null
      };

      this.currentStepIndex = 0;
      this.loading = false;
      this.collectionCache = new Map();
      this.state = this.getFreshState();
      this.goalTiersConfig = (this.config?.goal?.tiers || [])
        .filter((tier) => Number(tier.amount || 0) > 0)
        .sort((a, b) => Number(a.amount || 0) - Number(b.amount || 0));

      this.activePreview = { shellId: null, grillId: null };
      this.expanded = { grills: false, keychains: false };
      this.sheetTouch = { startY: 0, currentY: 0, dragging: false };

      this.boundHandleClick = this.handleClick.bind(this);
      this.boundHandleKeydown = this.handleKeydown.bind(this);
      this.boundHandleInput = this.handleInput.bind(this);

      this.unlockedTiers = new Set();
      this.previousSubtotal = this.getSubtotalCents();
      this.suppressUnlockAnimations = false;
      this.allProductsCache = new Map();
      this.renderRequestId = 0;
      this.activeUpsellCollectionHandle = null;
      this.unlockOverlay = root.querySelector('[data-jrb-unlock]');
      this.unlockLabel = root.querySelector('[data-jrb-unlock-label]');
      this.unlockSubtext = root.querySelector('[data-jrb-unlock-subtext]');
      this.unlockIcon = root.querySelector('[data-jrb-unlock-icon]');
      this.unlockTimer = null;
      this.lastPreviewScroll = { shellId: null, grillId: null };
      this.maxSafePreviewQuantity = 200;

      this.init();
    }

    readConfig() {
      if (!this.configNode) return null;
      try {
        const parsed = JSON.parse(this.configNode.textContent);
        parsed.columns = parsed.columns || {};
        parsed.goal = parsed.goal || {};
        parsed.goal.tiers = Array.isArray(parsed.goal.tiers) ? parsed.goal.tiers : [];
        return parsed;
      } catch (error) {
        console.error('Jack Rack Builder config parse failed', error);
        return null;
      }
    }

    getFreshState() {
      return { shell: [], brands: [], grills: [], keychains: [], upsell: [] };
    }

    updateLauncherVisibility() {
      const launcher = this.launcherButton || this.root.querySelector('[data-jrb-open]');
      if (!launcher) return;

      const path = String(window.location.pathname || '').toLowerCase();
      const onCart = path === '/cart' || path.startsWith('/cart/');
      const onCheckout = path.includes('/checkout') || path.includes('/checkouts/');

      const anyOpenDrawer = Boolean(
        document.querySelector('.menu-drawer[open], .menu-drawer.is-open, .cart-drawer[open], .cart-drawer.is-open, .drawer[open], .drawer.is-open, details[open]')
      );

      const anyOpenDialog = Boolean(
        document.querySelector('[aria-modal="true"], dialog[open], .modal.is-open')
      );

      const overlayOpen = Boolean(this.overlay && this.overlay.classList.contains('is-open'));
      const shouldHide = onCart || onCheckout || anyOpenDrawer || anyOpenDialog || overlayOpen;

      launcher.style.display = shouldHide ? 'none' : '';
    }

    bindLauncherVisibility() {
      this.updateLauncherVisibility();

      const deferredUpdate = () => {
        window.setTimeout(() => this.updateLauncherVisibility(), 40);
      };

      window.addEventListener('pageshow', deferredUpdate);
      window.addEventListener('popstate', deferredUpdate);
      window.addEventListener('hashchange', deferredUpdate);
      document.addEventListener('click', deferredUpdate, true);

      if ('MutationObserver' in window) {
        this.launcherVisibilityObserver = new MutationObserver(() => deferredUpdate());
        this.launcherVisibilityObserver.observe(document.body, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['class', 'open', 'aria-hidden']
        });
      }
    }

    updateFooterHeightVar() {
      if (!this.footer) return;

      const applyHeight = () => {
        const height = Math.ceil(this.footer.offsetHeight || 0);
        if (height > 0) {
          this.root.style.setProperty('--jrb-footer-height', `${height}px`);
        }
      };

      applyHeight();
      window.requestAnimationFrame(applyHeight);
    }

    init() {
      if (!this.config || !this.overlay || !this.body || !this.summary || !this.prevButton || !this.nextButton) return;
      this.root.addEventListener('click', this.boundHandleClick);
      this.setupMobileSheet();
      this.root.addEventListener('input', this.boundHandleInput);
      document.addEventListener('keydown', this.boundHandleKeydown);
      this.renderBackgroundDots();
      this.updateBackground();
      this.setupBackgroundControls();
      this.updateFooter();
      this.updateGoalMeter();
      this.refreshCartSubtotal();
      this.bindLauncherVisibility();
      this.updateFooterHeightVar();
      window.addEventListener('resize', () => this.updateFooterHeightVar());
      window.addEventListener('orientationchange', () => this.updateFooterHeightVar());
    }

    async refreshCartSubtotal() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (typeof cart?.total_price === 'number') {
          this.cartSubtotalCents = Number(cart.total_price || 0);
          if (this.suppressUnlockAnimations || this.overlay?.classList.contains('is-open')) {
            this.previousSubtotal = this.getSubtotalCents();
          }
          this.updateFooter();
        }
      } catch (error) {
        console.warn('Jack Rack Builder cart subtotal refresh failed', error);
      }
    }


    triggerUnlock(tier) {
      if (!this.unlockOverlay) return;

      if (this.unlockTimer) {
        clearTimeout(this.unlockTimer);
        this.unlockTimer = null;
      }

      this.unlockLabel.textContent = tier.label || '';
      if (this.unlockSubtext) {
        const subtext = String(tier.popupText || '').trim();
        this.unlockSubtext.textContent = subtext;
        this.unlockSubtext.hidden = !subtext;
      }
      this.unlockIcon.innerHTML = tier.image
        ? `<img src="${this.escapeAttribute(tier.image)}" alt="${this.escapeAttribute(tier.label || 'Reward')}">`
        : '';

      this.unlockOverlay.classList.add('active');

      this.unlockTimer = setTimeout(() => {
        this.unlockOverlay.classList.remove('active');
      }, 2100);
    }

    clearPreviewCoach(immediate = false) {
      if (this.previewCoachTimer) {
        clearTimeout(this.previewCoachTimer);
        this.previewCoachTimer = null;
      }
      this.previewCoachActive = null;
      if (!this.previewCoach) return;

      if (immediate) {
        this.previewCoach.classList.remove('is-visible', 'is-stage', 'is-shell', 'is-grill');
        if (this.previewCoachTag) {
          this.previewCoachTag.hidden = true;
          this.previewCoachTag.removeAttribute('src');
        }
        this.previewCoach.hidden = true;
        return;
      }

      this.previewCoach.classList.remove('is-visible');
      const coachTag = this.previewCoachTag;
      const coach = this.previewCoach;
      window.setTimeout(() => {
        if (!coach || coach.classList.contains('is-visible')) return;
        coach.classList.remove('is-stage', 'is-shell', 'is-grill');
        if (coachTag) {
          coachTag.hidden = true;
          coachTag.removeAttribute('src');
        }
        coach.hidden = true;
      }, 360);
    }

    showPreviewCoach(type) {
      if (!this.previewCoach || !this.previewCoachTag) return;
      if (this.previewCoachActive === type) return;

      const coachImage = this.config?.coach?.[`${type}Image`];
      if (!coachImage) return;

      this.clearPreviewCoach(true);
      this.previewCoach.hidden = false;
      this.previewCoachTag.src = coachImage;
      this.previewCoachTag.alt = `${type} coach tag`;
      this.previewCoachTag.hidden = false;
      this.previewCoach.classList.add('is-visible', `is-${type}`);
      this.previewCoachActive = type;
      this.previewCoachSeen[type] = true;

      this.previewCoachTimer = setTimeout(() => {
        this.clearPreviewCoach(false);
        window.setTimeout(() => this.maybeShowPreviewCoach(), 380);
      }, 4000);
    }

    maybeShowPreviewCoach() {
      if (!this.overlay || !this.overlay.classList.contains('is-open')) return;
      this.syncPreviewCoachVisibility();
      if (this.previewCoachActive) return;

      const shellVisible = this.shellSelectorGroup && !this.shellSelectorGroup.hidden;
      const grillVisible = this.grillSelectorGroup && !this.grillSelectorGroup.hidden;
      const shellCount = Array.isArray(this.state.shell) ? this.state.shell.length : 0;
      const grillCount = Array.isArray(this.state.grills) ? this.state.grills.length : 0;

      if (!this.previewCoachSeen.stage && this.bgDots && this.bgDots.children.length) {
        this.showPreviewCoach('stage');
        return;
      }

      if (!this.previewCoachSeen.shell && shellVisible && shellCount > 1) {
        this.showPreviewCoach('shell');
        return;
      }

      if (!this.previewCoachSeen.grill && grillVisible && grillCount > 1) {
        this.showPreviewCoach('grill');
      }
    }

    syncPreviewCoachVisibility() {
      const shellCount = Array.isArray(this.state.shell) ? this.state.shell.length : 0;
      const grillCount = Array.isArray(this.state.grills) ? this.state.grills.length : 0;

      if (this.previewCoachActive === 'stage' && shellCount >= 2) {
        this.clearPreviewCoach(true);
        return;
      }

      if (this.previewCoachActive === 'shell' && shellCount >= 3) {
        this.clearPreviewCoach(true);
        return;
      }

      if (this.previewCoachActive === 'grill' && grillCount >= 3) {
        this.clearPreviewCoach(true);
      }
    }

    renderBackgroundDots() {
      if (!this.bgDots || !this.backgrounds.length) return;

      this.bgDots.innerHTML = this.backgrounds
        .map((bg, index) => {
          const activeClass = index === this.currentBackgroundIndex ? 'is-active' : '';
          const aria = bg.id === 'plain-white'
            ? 'Select plain white background'
            : `Select background ${index + 1}`;

          return `<button type="button" class="jrb-preview__bg-dot ${activeClass}" data-jrb-bg-dot="${index}" aria-label="${aria}"></button>`;
        })
        .join('');
    }

    preloadImage(src) {
      return new Promise((resolve) => {
        if (!src) {
          resolve(false);
          return;
        }
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = src;
      });
    }

    async updateBackground() {
      if (!this.backgrounds.length || !this.bgLayer || !this.bgImage) return;

      const bg = this.backgrounds[this.currentBackgroundIndex];
      if (!bg) return;

      if (!bg.image) {
        this.bgLayer.style.backgroundColor = bg.color || '#ffffff';
        this.bgImage.hidden = true;
        this.bgImage.removeAttribute('src');
      } else {
        const loaded = await this.preloadImage(bg.image);
        if (loaded) {
          this.bgLayer.style.backgroundColor = '#ffffff';
          this.bgImage.src = bg.image;
          this.bgImage.hidden = false;
        } else {
          this.bgLayer.style.backgroundColor = '#ffffff';
          this.bgImage.hidden = true;
          this.bgImage.removeAttribute('src');
        }
      }

      if (this.bgDots) {
        this.bgDots.querySelectorAll('[data-jrb-bg-dot]').forEach((dot) => {
          const index = Number(dot.dataset.jrbBgDot);
          dot.classList.toggle('is-active', index === this.currentBackgroundIndex);
        });
      }
    }

    nextBackground() {
      if (!this.backgrounds.length) return;
      this.currentBackgroundIndex = (this.currentBackgroundIndex + 1) % this.backgrounds.length;
      this.updateBackground();
    }

    prevBackground() {
      if (!this.backgrounds.length) return;
      this.currentBackgroundIndex = (this.currentBackgroundIndex - 1 + this.backgrounds.length) % this.backgrounds.length;
      this.updateBackground();
    }

    setupBackgroundControls() {
      if (!this.previewStage) return;

      this.previewStage.addEventListener('touchstart', (event) => {
        if (!event.touches.length) return;
        const touch = event.touches[0];
        this.bgTouch.startX = touch.clientX;
        this.bgTouch.startY = touch.clientY;
        this.bgTouch.currentX = touch.clientX;
        this.bgTouch.currentY = touch.clientY;
        this.bgTouch.dragging = true;
        this.bgTouch.lockedAxis = null;
      }, { passive: true });

      this.previewStage.addEventListener('touchmove', (event) => {
        if (!this.bgTouch.dragging || !event.touches.length) return;

        const touch = event.touches[0];
        this.bgTouch.currentX = touch.clientX;
        this.bgTouch.currentY = touch.clientY;

        const deltaX = this.bgTouch.currentX - this.bgTouch.startX;
        const deltaY = this.bgTouch.currentY - this.bgTouch.startY;

        if (!this.bgTouch.lockedAxis) {
          if (Math.abs(deltaY) > 10 && Math.abs(deltaY) > Math.abs(deltaX)) {
            this.bgTouch.lockedAxis = 'vertical';
          } else if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
            this.bgTouch.lockedAxis = 'horizontal';
          }
        }

        if (this.bgTouch.lockedAxis === 'vertical') {
          event.preventDefault();
        }
      }, { passive: false });

      this.previewStage.addEventListener('touchend', (event) => {
        if (!this.bgTouch.dragging) return;

        let endX = this.bgTouch.currentX;
        let endY = this.bgTouch.currentY;

        if (event.changedTouches.length) {
          endX = event.changedTouches[0].clientX;
          endY = event.changedTouches[0].clientY;
        }

        const deltaX = endX - this.bgTouch.startX;
        const deltaY = endY - this.bgTouch.startY;

        const flattenedKeyCount = this.getTotalKeyQuantity();

        if (Math.abs(deltaX) >= 32 && Math.abs(deltaX) > Math.abs(deltaY) && flattenedKeyCount > 4) {
          const maxKeyStart = Math.max(0, flattenedKeyCount - 4);
          if (deltaX < 0) {
            this.previewKeyStartIndex = Math.min(maxKeyStart, this.previewKeyStartIndex + 1);
          } else {
            this.previewKeyStartIndex = Math.max(0, this.previewKeyStartIndex - 1);
          }
          this.updatePreview();
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
        } else if (Math.abs(deltaY) >= 40 && Math.abs(deltaY) > Math.abs(deltaX)) {
          if (deltaY < 0) {
            this.nextBackground();
          } else {
            this.prevBackground();
          }
        }

        this.bgTouch.dragging = false;
        this.bgTouch.lockedAxis = null;
      }, { passive: true });

      this.previewStage.addEventListener('wheel', (event) => {
        if (window.innerWidth <= 749) return;
        event.preventDefault();

        if (event.deltaY > 0) {
          this.nextBackground();
        } else {
          this.prevBackground();
        }
      }, { passive: false });

      if (this.bgDots) {
        this.bgDots.addEventListener('click', (event) => {
          const dot = event.target.closest('[data-jrb-bg-dot]');
          if (!dot) return;
          this.currentBackgroundIndex = Number(dot.dataset.jrbBgDot);
          this.updateBackground();
        });
      }
    }

    getTotalKeyQuantity() {
      return this.state.keychains.reduce((sum, item) => {
        const qty = Math.max(1, Number(item.quantity || 1));
        return sum + Math.min(qty, this.maxSafePreviewQuantity);
      }, 0);
    }

    getVisiblePreviewKeys() {
      const totalKeyQuantity = this.getTotalKeyQuantity();
      const maxKeyStart = Math.max(0, totalKeyQuantity - 4);

      if (this.previewKeyStartIndex > maxKeyStart) this.previewKeyStartIndex = maxKeyStart;
      if (totalKeyQuantity <= 4) this.previewKeyStartIndex = 0;

      let skip = this.previewKeyStartIndex;
      const visibleKeys = [];

      for (const item of this.state.keychains) {
        const repeatCount = Math.min(Math.max(1, Number(item.quantity || 1)), this.maxSafePreviewQuantity);

        if (skip >= repeatCount) {
          skip -= repeatCount;
          continue;
        }

        const startIndex = skip;
        const remainingSlots = 4 - visibleKeys.length;
        const takeCount = Math.min(repeatCount - startIndex, remainingSlots);

        for (let i = 0; i < takeCount; i += 1) {
          visibleKeys.push(item);
        }

        skip = 0;
        if (visibleKeys.length >= 4) break;
      }

      return visibleKeys;
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.overlay.classList.contains('is-open')) {
        this.close();
        return;
      }

      const card = event.target.closest('[data-jrb-card]');
      if (!card) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggleSelection(card);
      }
    }

    handleInput(event) {
      const qtyInput = event.target.closest('[data-jrb-qty-input]');
      if (qtyInput) {
        const id = String(qtyInput.dataset.jrbQtyInput);
        const stateKey = String(qtyInput.dataset.jrbStateKey || 'keychains');
        let value = parseInt(qtyInput.value, 10);
        if (Number.isNaN(value) || value < 1) value = 1;
        const item = this.state[stateKey]?.find((entry) => String(entry.id) === id);
        if (!item) return;
        item.quantity = value;
        qtyInput.value = String(value);
        if (stateKey === 'keychains') {
          const flattenedKeyCount = this.getTotalKeyQuantity();
          this.previewKeyStartIndex = Math.max(0, flattenedKeyCount - 4);
        }
        this.updateCardSelectionState();
        this.updateFooter();
        this.updatePreview();
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
        return;
      }

      const variantSelect = event.target.closest('[data-jrb-variant-select]');
      if (variantSelect) {
        const id = String(variantSelect.dataset.jrbVariantSelect);
        const stateKey = String(variantSelect.dataset.jrbStateKey || '');
        const item = this.state[stateKey]?.find((entry) => String(entry.id) === id);
        const collection = this.getCurrentStepProducts();
        const product = collection.find((entry) => String(entry.id) === id);
        if (!item || !product) return;
        item.variantId = String(variantSelect.value || '');
        item.price = this.getProductPriceCents(product, item.variantId);
        this.updateCardSelectionState();
        this.updateFooter();
      }
    }

    handleClick(event) {
      const openTrigger = event.target.closest('[data-jrb-open]');
      const closeTrigger = event.target.closest('[data-jrb-close]');
      const prevTrigger = event.target.closest('[data-jrb-prev]');
      const nextTrigger = event.target.closest('[data-jrb-next]');
      const qtyButton = event.target.closest('[data-jrb-qty-button]');
      const variantBubble = event.target.closest('[data-jrb-variant-bubble]');
      const previewLeft = event.target.closest('[data-jrb-preview-left]');
const previewRight = event.target.closest('[data-jrb-preview-right]');
const previewThumb = event.target.closest('[data-jrb-preview-thumb]');
      const seeMoreTrigger = event.target.closest('[data-jrb-see-more]');
      const upsellCollectionTrigger = event.target.closest('[data-jrb-upsell-collection]');
      const upsellBackTrigger = event.target.closest('[data-jrb-upsell-back]');
      const cardTrigger = event.target.closest('[data-jrb-card]');

      if (openTrigger) { event.preventDefault(); this.open(); return; }
      if (closeTrigger) { event.preventDefault(); this.close(); return; }
      if (event.target === this.overlay) { this.close(); return; }
      if (prevTrigger) { event.preventDefault(); this.goPrevious(); return; }
      if (nextTrigger) { event.preventDefault(); this.goNext(); return; }
      if (qtyButton) { event.preventDefault(); event.stopPropagation(); this.adjustQuantity(qtyButton); return; }
      if (variantBubble) { event.preventDefault(); event.stopPropagation(); this.selectVariantBubble(variantBubble); return; }
      if (previewLeft) { event.preventDefault(); this.shiftPreview(-1); return; }
if (previewRight) { event.preventDefault(); this.shiftPreview(1); return; }
if (previewThumb) { event.preventDefault(); this.setActivePreview(previewThumb.dataset.jrbPreviewType, String(previewThumb.dataset.jrbPreviewId)); return; }
      if (seeMoreTrigger) { event.preventDefault(); this.handleSeeMore(seeMoreTrigger.dataset.jrbSeeMore); return; }
      if (upsellBackTrigger) { event.preventDefault(); this.activeUpsellCollectionHandle = null; this.renderCurrentStep(); return; }
      if (upsellCollectionTrigger) { event.preventDefault(); this.activeUpsellCollectionHandle = String(upsellCollectionTrigger.dataset.jrbUpsellCollection || ''); this.renderCurrentStep(); return; }
      if (cardTrigger) { event.preventDefault(); this.toggleSelection(cardTrigger); }
    }

    adjustQuantity(button) {
      const id = String(button.dataset.jrbQtyButton);
      const stateKey = String(button.dataset.jrbStateKey || 'keychains');
      const delta = Number(button.dataset.delta || 0);
      const item = this.state[stateKey]?.find((entry) => String(entry.id) === id);
      if (!item) return;
      item.quantity = Math.max(1, Number(item.quantity || 1) + delta);
      if (stateKey === 'keychains') {
        const flattenedKeyCount = this.getTotalKeyQuantity();
        this.previewKeyStartIndex = Math.max(0, flattenedKeyCount - 4);
      }
      this.updateCardSelectionState();
      this.updateFooter();
      this.updatePreview();
      this.preloadImageSet(this.state.keychains.map((entry) => this.getSizedImage(entry?.image, 220)));
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
      this.updateFooterHeightVar();
    }

    selectVariantBubble(button) {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      const id = String(button.dataset.jrbVariantProduct || '');
      const stateKey = String(button.dataset.jrbStateKey || '');
      const variantId = String(button.dataset.jrbVariantId || '');
      if (!id || !stateKey || !variantId) return;

      const item = this.state[stateKey]?.find((entry) => String(entry.id) === id);
      const collection = this.getCurrentStepProducts();
      const product = collection.find((entry) => String(entry.id) === id);
      if (!item || !product) return;

      item.variantId = variantId;
      item.price = this.getProductPriceCents(product, variantId);
      this.updateCardSelectionState();
      this.updateFooter();
      this.updatePreview();
      this.preloadImageSet(this.state.keychains.map((entry) => this.getSizedImage(entry?.image, 220)));
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
    }

    shiftPreview(dir) {
  const total = this.getTotalKeyQuantity();
  if (total <= 4) return;
  const maxIndex = Math.max(0, total - 4);
  this.previewKeyStartIndex = Math.min(maxIndex, Math.max(0, this.previewKeyStartIndex + dir));
  this.updatePreview();
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
}

open() {
      this.currentStepIndex = 0;
      this.state = this.getFreshState();
      this.activePreview = { shellId: null, grillId: null };
      this.expanded = { grills: false, keychains: false };
      this.sheetTouch = { startY: 0, currentY: 0, dragging: false };
      this.unlockedTiers = new Set();
      this.suppressUnlockAnimations = true;
      this.previousSubtotal = this.getSubtotalCents();
      this.currentBackgroundIndex = 0;
      this.previewKeyStartIndex = 0;
      this.previewCoachSeen = { stage: false, shell: false, grill: false };
      this.clearPreviewCoach(true);

      this.overlay.classList.add('is-open');
      const modal = this.root.querySelector('.jrb-modal');
      if (modal) modal.style.transform = '';
      this.overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      this.updateBackground();
      this.updatePreview();
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
      this.renderCurrentStep();
      this.updateGoalMeter();
      Promise.resolve(this.refreshCartSubtotal()).finally(() => {
        this.previousSubtotal = this.getSubtotalCents();
        this.suppressUnlockAnimations = false;
        this.updateFooterHeightVar();
      });
      this.updateLauncherVisibility();
      this.updateFooterHeightVar();
    }

    close() {
      this.overlay.classList.remove('is-open');
      const modal = this.root.querySelector('.jrb-modal');
      if (modal) modal.style.transform = '';
      this.overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
      this.suppressUnlockAnimations = false;
      this.clearPreviewCoach(true);
      this.updateLauncherVisibility();
      this.updateFooterHeightVar();
    }

    scrollStepToTop() {
      if (this.scrollArea) this.scrollArea.scrollTo({ top: 0, behavior: 'smooth' });
    }

    setupMobileSheet() {
      const header = this.root.querySelector('.jrb-modal__header');
      const modal = this.root.querySelector('.jrb-modal');
      if (!header || !modal) return;

      const start = (y) => {
        if (window.innerWidth > 749) return;
        this.sheetTouch = { startY: y, currentY: y, dragging: true };
        modal.style.transition = 'none';
      };

      const move = (y) => {
        if (!this.sheetTouch.dragging || window.innerWidth > 749) return;
        this.sheetTouch.currentY = y;
        const delta = Math.max(0, y - this.sheetTouch.startY);
        modal.style.transform = `translateY(${delta}px)`;
      };

      const end = () => {
        if (!this.sheetTouch.dragging || window.innerWidth > 749) return;
        const delta = Math.max(0, this.sheetTouch.currentY - this.sheetTouch.startY);
        this.sheetTouch.dragging = false;
        modal.style.transition = 'transform .28s ease';
        if (delta > 120) {
          this.close();
        } else {
          modal.style.transform = 'translateY(0)';
        }
      };

      header.addEventListener('touchstart', (e) => start(e.touches[0].clientY), { passive: true });
      header.addEventListener('touchmove', (e) => move(e.touches[0].clientY), { passive: true });
      header.addEventListener('touchend', end);
    }

    handleSeeMore(type) {
      if (!type) return;
      this.expanded[type] = true;
      this.renderCurrentStep();
    }

    async fetchTaggedProductsFromAllCollections(tag) {
      const normalizedTag = (tag || '').trim().toLowerCase();
      const cacheKey = normalizedTag || '__all__';
      if (this.allProductsCache.has(cacheKey)) {
        return this.allProductsCache.get(cacheKey);
      }

      const endpoint = `${window.Shopify?.routes?.root || '/'}products.json?limit=250`;
      const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('All products request failed');
      const data = await response.json();
      const products = (Array.isArray(data.products) ? data.products : []).filter((product) => this.productIsAvailable(product));
      const deduped = new Map();

      products.forEach((product) => {
        if (!product || !product.id) return;
        if (normalizedTag && !this.productHasTag(product, normalizedTag)) return;
        if (!deduped.has(String(product.id))) deduped.set(String(product.id), product);
      });

      const results = Array.from(deduped.values());
      this.allProductsCache.set(cacheKey, results);
      return results;
    }


    getUpsellCollections() {
      return Array.isArray(this.config?.upsellCollections)
        ? this.config.upsellCollections.filter((item) => item && item.handle)
        : [];
    }

    getActiveUpsellCollectionMeta() {
      const collections = this.getUpsellCollections();
      if (!collections.length || !this.activeUpsellCollectionHandle) return null;
      return collections.find((item) => String(item.handle) === String(this.activeUpsellCollectionHandle)) || null;
    }

getUpsellDiscountContext(meta = this.getActiveUpsellCollectionMeta(), subtotal = this.getSubtotalCents()) {
  if (!meta) return { eligible: false, threshold: 0, percent: 0, remaining: 0, code: '', text: '' };

  const thresholdDollars = Math.max(0, Number(meta.discountThreshold || 0));
  const threshold = Math.round(thresholdDollars * 100);
  const percent = Math.max(0, Number(meta.discountPercent || 0));
  const eligible = threshold > 0 && percent > 0 && subtotal >= threshold;
  const remaining = Math.max(threshold - subtotal, 0);
  const code = String(meta.discountCode || '').trim();

  let text = '';
  if (threshold > 0 && percent > 0) {
    text = eligible
      ? `Unlocked ${percent}% off${code ? ` with code ${code}` : ''}`
      : `Spend ${this.formatPrice(remaining)} more to unlock ${percent}% off`;
  }

  return { eligible, threshold, percent, remaining, code, text };
}

    getDisplayPriceHtml(product, stateKey) {
      const selectedEntry = this.state[stateKey]?.find((item) => String(item.id) === String(product.id)) || null;
      const basePrice = this.getProductPriceCents(product, selectedEntry?.variantId || null);

      if (stateKey !== 'upsell') {
        return this.formatPrice(basePrice);
      }

      const meta = this.getActiveUpsellCollectionMeta();
      const discount = this.getUpsellDiscountContext(meta);
      const subtotal = this.getSubtotalCents();

      const thresholdReached =
        Number(discount.threshold || 0) > 0 &&
        Number(discount.percent || 0) > 0 &&
        subtotal >= Number(discount.threshold || 0);

      if (!thresholdReached) {
        return this.formatPrice(basePrice);
      }

      const discounted = Math.max(
        0,
        Math.round(basePrice * (1 - Number(discount.percent || 0) / 100))
      );

      return `<span class="jrb-price"><span class="jrb-price__compare">${this.formatPrice(basePrice)}</span><span class="jrb-price__discounted">${this.formatPrice(discounted)}</span></span>`;
    }

    refreshUpsellPricingInView() {
      const currentStep = this.getCurrentStepConfig();
      if (!currentStep || currentStep.key !== 'upsell') return;
      if (!this.body) return;

      const products = this.getCurrentStepProducts();
      const activeMeta = this.getActiveUpsellCollectionMeta();
      const discount = this.getUpsellDiscountContext(activeMeta);

      const toolbarCallout = this.body.querySelector('.jrb-upsell-toolbar__callout');
      if (toolbarCallout) {
        toolbarCallout.textContent = discount.text || '';
        toolbarCallout.style.display = discount.text ? '' : 'none';
      }

      if (!Array.isArray(products) || !products.length) return;

      this.body.querySelectorAll('[data-jrb-card][data-jrb-type="upsell"]').forEach((card) => {
        const id = String(card.dataset.jrbId || '');
        const product = products.find((item) => String(item.id) === id);
        if (!product) return;

        const metaEl = card.querySelector('.jrb-card__meta');
        if (!metaEl) return;

        metaEl.innerHTML = this.getDisplayPriceHtml(product, 'upsell');
      });
    }

    renderUpsellCollectionCard(item) {
      const selected = String(this.activeUpsellCollectionHandle || '') === String(item.handle || '');
      const discount = this.getUpsellDiscountContext(item);
      const callout = discount.text
        ? `<p class="jrb-upsell-collection__callout">${this.escapeHtml(discount.text)}</p>`
        : '';

      return `<button type="button" class="jrb-upsell-collection ${selected ? 'is-selected' : ''}" data-jrb-upsell-collection="${this.escapeAttribute(item.handle)}" aria-label="${this.escapeAttribute(item.title || 'Upsell collection')}">
        <div class="jrb-upsell-collection__image-wrap">
          <img class="jrb-upsell-collection__image" src="${this.escapeAttribute(item.image || PLACEHOLDER_IMAGE)}" alt="${this.escapeAttribute(item.title || 'Upsell collection')}" loading="lazy">
        </div>
        <div class="jrb-upsell-collection__body">
          <h4 class="jrb-upsell-collection__title">${this.escapeHtml(item.title || '')}</h4>
          ${callout}
        </div>
      </button>`;
    }

    renderUpsellCollectionsView() {
      const collections = this.getUpsellCollections();
      if (!collections.length) return '';
      return `<div class="jrb-upsell-collections" style="--jrb-cols:${this.getStepColumns('upsell')}">${collections.map((item) => this.renderUpsellCollectionCard(item)).join('')}</div>`;
    }

    renderUpsellCollectionToolbar(meta) {
      if (!meta) return '';
      const discount = this.getUpsellDiscountContext(meta);
      const callout = discount.text
        ? `<p class="jrb-upsell-toolbar__callout">${this.escapeHtml(discount.text)}</p>`
        : '';

      return `<div class="jrb-upsell-toolbar">
        <div class="jrb-upsell-toolbar__copy">
          <p class="jrb-upsell-toolbar__title">${this.escapeHtml(meta.title || '')}</p>
          ${callout}
        </div>
        <button type="button" class="jrb-upsell-back" data-jrb-upsell-back>Back</button>
      </div>`;
    }

    getApplicableUpsellDiscountCode() {
      const meta = this.getActiveUpsellCollectionMeta();
      const discount = this.getUpsellDiscountContext(meta);
      if (!discount.eligible || !discount.code || !this.state.upsell.length) return '';
      return discount.code;
    }

    renderCarousel(items, stateKey, showSeeMore = false) {
      const cards = items.map((product) => this.renderProductCard(product, stateKey)).join('');
      const label = stateKey === 'grills' ? 'View all grills' : stateKey === 'keychains' ? 'View all keychains' : 'See more';
      const seeMoreCard = showSeeMore
        ? `<button type="button" class="jrb-card jrb-card--see-more" data-jrb-see-more="${stateKey}" aria-label="${label}"><div class="jrb-card__body"><h4 class="jrb-card__title">See More</h4><p class="jrb-card__meta">${label}</p></div></button>`
        : '';
      return `<div class="jrb-carousel">${cards}${seeMoreCard}</div>`;
    }

    renderProductGrid(items, stateKey) {
      return `<div class="jrb-grid" style="--jrb-cols:${this.getStepColumns(stateKey)}">${items.map((product) => this.renderProductCard(product, stateKey)).join('')}</div>`;
    }

    setActivePreview(type, id) {
      if (type === 'shell') this.activePreview.shellId = String(id);
      if (type === 'grill') this.activePreview.grillId = String(id);
      this.updatePreview();
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
    }

    renderPreviewSelector(type, items, activeId) {
      const target = type === 'shell' ? this.shellSelector : this.grillSelector;
      const group = type === 'shell' ? this.shellSelectorGroup : this.grillSelectorGroup;
      if (!target || !group) return;

      if (!items.length || items.length === 1) {
        target.innerHTML = '';
        group.hidden = true;
        return;
      }

      group.hidden = false;
      target.classList.toggle('is-centered', items.length <= 3);
      target.innerHTML = items
        .map((item) => `
          <button type="button" class="jrb-preview__thumb ${String(item.id) === String(activeId) ? 'is-active' : ''}" data-jrb-preview-thumb data-jrb-preview-type="${type}" data-jrb-preview-id="${item.id}" aria-label="Preview ${this.escapeAttribute(item.title || type)}">
            <img src="${this.escapeAttribute(item.image || PLACEHOLDER_IMAGE)}" alt="${this.escapeAttribute(item.title || type)}" loading="lazy">
          </button>
        `)
        .join('');

      const activeChanged =
        (type === 'shell' && this.lastPreviewScroll.shellId !== String(activeId || '')) ||
        (type === 'grill' && this.lastPreviewScroll.grillId !== String(activeId || ''));

      if (activeChanged && items.length > 3) {
        requestAnimationFrame(() => {
          const activeThumb = target.querySelector('.jrb-preview__thumb.is-active');
          if (!activeThumb) return;

          const thumbLeft = activeThumb.offsetLeft;
          const thumbWidth = activeThumb.offsetWidth;
          const listWidth = target.clientWidth;
          const desiredLeft = Math.max(0, thumbLeft - (listWidth / 2) + (thumbWidth / 2));

          target.scrollTo({
            left: desiredLeft,
            behavior: 'smooth'
          });
        });
      }

      if (type === 'shell') this.lastPreviewScroll.shellId = String(activeId || '');
      if (type === 'grill') this.lastPreviewScroll.grillId = String(activeId || '');
    }

    updatePreview() {
      const currentStep = this.getCurrentStepConfig();
      const hidePreview = currentStep && currentStep.key === 'upsell';

      if (this.previewWrap) {
        this.previewWrap.classList.toggle('jrb-hidden', Boolean(hidePreview));
      }

      const shells = this.state.shell || [];
      const grills = this.state.grills || [];

      if (shells.length && !shells.some((item) => String(item.id) === String(this.activePreview.shellId))) {
        this.activePreview.shellId = String(shells[0].id);
      }
      if (!shells.length) this.activePreview.shellId = null;

      if (grills.length && !grills.some((item) => String(item.id) === String(this.activePreview.grillId))) {
        this.activePreview.grillId = String(grills[0].id);
      }
      if (!grills.length) this.activePreview.grillId = null;

      const activeShell = shells.find((item) => String(item.id) === String(this.activePreview.shellId)) || null;
      const activeGrill = grills.find((item) => String(item.id) === String(this.activePreview.grillId)) || null;

      if (this.previewShell) {
        if (activeShell?.image) {
          this.previewShell.src = activeShell.image;
          this.previewShell.alt = activeShell.title || '';
          this.previewShell.hidden = false;
          if (this.previewShellPlaceholder) this.previewShellPlaceholder.hidden = true;
        } else {
          this.previewShell.hidden = true;
          this.previewShell.removeAttribute('src');
          if (this.previewShellPlaceholder) this.previewShellPlaceholder.hidden = false;
        }
      }

      if (this.previewGrill) {
        if (activeGrill?.image) {
          this.previewGrill.src = activeGrill.image;
          this.previewGrill.alt = activeGrill.title || '';
          this.previewGrill.hidden = false;
        } else {
          this.previewGrill.hidden = true;
          this.previewGrill.removeAttribute('src');
        }
      }

      const visibleKeys = this.getVisiblePreviewKeys();

      this.previewKeys.forEach((img, index) => {
        if (!img) return;
        const item = visibleKeys[index];
        const placeholder = img.parentElement?.querySelector(`.jrb-preview__key-placeholder.key-${index + 1}`);
        if (item?.image) {
          img.src = item.image;
          img.alt = item.title || '';
          img.hidden = false;
          if (placeholder) placeholder.hidden = true;
        } else {
          img.hidden = true;
          img.removeAttribute('src');
          if (placeholder) placeholder.hidden = false;
        }
      });

      this.renderPreviewSelector('shell', shells, this.activePreview.shellId);
      this.renderPreviewSelector('grill', grills, this.activePreview.grillId);
      this.maybeShowPreviewCoach();
    }

    updateProgressMeter() {
      const maxTier = Math.max(...this.goalTiersConfig.map((t) => Number(t.amount || 0)), 7500, 0);
      const subtotal = this.getSubtotalCents();
      const percent = maxTier > 0 ? Math.max(0, Math.min((subtotal / maxTier) * 100, 100)) : 0;

      if (this.progressFill) {
        if (window.innerWidth <= 749) {
          this.progressFill.style.width = `${percent}%`;
          this.progressFill.style.height = '100%';
        } else {
          this.progressFill.style.height = `${percent}%`;
          this.progressFill.style.width = '100%';
        }
      }

      if (this.mobileGoalRail) {
        this.mobileGoalRail.style.setProperty('--jrb-progress', `${percent}%`);
      }

      if (this.mobileGoalFill) {
        const visiblePercent = percent > 0 ? Math.max(percent, 8) : 0;
this.mobileGoalFill.style.width = `${visiblePercent}%`;
      }

      if (this.mobileGoalDots?.length) {
        this.mobileGoalDots.forEach((dot, index) => {
          const tier = this.goalTiersConfig[index];
          if (!tier) return;
          dot.classList.toggle('is-unlocked', subtotal >= Number(tier.amount || 0));
          const img = tier.image
            ? `<img src="${this.escapeAttribute(tier.image)}" alt="${this.escapeAttribute(tier.label || 'Reward')}" loading="lazy">`
            : '';
          if (dot.innerHTML !== img) dot.innerHTML = img;
        });
      }
    }

    updateFooter() {
      const step = this.config.steps[this.currentStepIndex];
      const isFirstStep = this.currentStepIndex === 0;

      this.prevButton.classList.toggle('jrb-hidden', isFirstStep);
      if (this.actions) this.actions.classList.toggle('is-single', isFirstStep);

      this.nextButton.textContent =
        this.currentStepIndex === this.config.steps.length - 1
          ? this.config.addLabel
          : this.config.nextLabel;

      this.nextButton.disabled =
        this.currentStepIndex === this.config.steps.length - 1
          ? !this.hasAnyPurchasableItems()
          : !this.isCurrentStepValid();

      this.renderSummary();
      if (this.kicker) this.kicker.textContent = step.description || this.config.modalSubtitle || '';
      this.updateProgressMeter();
      this.updateGoalMeter();
      this.refreshUpsellPricingInView();
      this.updatePreview();
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
    }

    renderSummary() {
      const parts = [
        { label: 'Shell', count: this.state.shell.length },
        { label: 'Grills', count: this.state.grills.length },
        { label: 'Keychains', count: this.state.keychains.reduce((sum, item) => sum + Number(item.quantity || 1), 0) }
      ];

      if (this.config.steps.some((step) => step.key === 'upsell')) {
        parts.push({ label: 'Add-ons', count: this.state.upsell.length });
      }

      this.summary.innerHTML = parts
        .map((item) => `<span class="jrb-summary__pill"><strong>${item.label}</strong> ${item.count} selected</span>`)
        .join('');
    }

    hasAnyPurchasableItems() {
      return [...this.state.shell, ...this.state.grills, ...this.state.keychains, ...this.state.upsell]
        .some((item) => item && item.variantId);
    }

    getBuilderSubtotalCents() {
      const shell = this.state.shell.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 1), 0);
      const grills = this.state.grills.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 1), 0);
      const keychains = this.state.keychains.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 1), 0);
      const upsell = this.state.upsell.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 1), 0);
      return Math.round(shell + grills + keychains + upsell);
    }

    getSubtotalCents() {
      return Math.round(Number(this.cartSubtotalCents || 0) + this.getBuilderSubtotalCents());
    }

    updateGoalMeter() {
      if (!this.goalTiers || !this.goalTotal) return;

      const subtotal = this.getSubtotalCents();
      const ascTiers = [...this.goalTiersConfig];

      this.goalTotal.textContent = this.formatPrice(subtotal);
      if (this.mobileGoalTotal) this.mobileGoalTotal.textContent = this.formatPrice(subtotal);

      const nextTier = ascTiers.find((t) => subtotal < Number(t.amount || 0));
      let hint = this.config.goal?.subtext || 'Add products to unlock rewards.';
      if (nextTier) {
        const remaining = Math.max(Number(nextTier.amount || 0) - subtotal, 0);
        hint = `Add ${this.formatPrice(remaining)} more to unlock ${nextTier.label}.`;
      } else if (ascTiers.length) {
        hint = ascTiers[ascTiers.length - 1].unlockedText || 'All unlockables reached.';
      }

      if (this.goalHint) this.goalHint.textContent = hint;
      if (this.mobileGoalHint) this.mobileGoalHint.textContent = hint;

      const maxTier = Math.max(...ascTiers.map((t) => Number(t.amount || 0)), 0);
      if (this.progressMarkers) {
        this.progressMarkers.innerHTML = [...ascTiers].reverse().map((tier) => {
          const amt = Number(tier.amount || 0);
          const pct = maxTier > 0 ? Math.max(0, Math.min((amt / maxTier) * 100, 100)) : 0;
          return `<div class="jrb-goal__marker" style="--jrb-marker:${pct}%"><span class="jrb-goal__marker-label">${this.formatPrice(amt)}</span></div>`;
        }).join('');
      }

      this.goalTiers.innerHTML = [...ascTiers].slice().reverse().map((tier) => {
        const amount = Number(tier.amount || 0);
        const unlocked = subtotal >= amount;

        if (!this.suppressUnlockAnimations && unlocked && this.previousSubtotal < amount) {
          this.unlockedTiers.add(amount);
          this.triggerUnlock(tier);
        }

        const message = unlocked
          ? (tier.unlockedText || 'Unlocked.')
          : (tier.lockedText || `Spend ${this.formatPrice(Math.max(amount - subtotal, 0))} more`);

        const img = tier.image
          ? `<img class="jrb-goal__image" src="${this.escapeAttribute(tier.image)}" alt="${this.escapeAttribute(tier.label || 'Reward')}" loading="lazy">`
          : `<div class="jrb-goal__dot">${unlocked ? '✓' : '•'}</div>`;

        return `<div class="jrb-goal__tier ${unlocked ? 'is-unlocked' : ''}"><div class="jrb-goal__image-wrap">${img}</div><div><p class="jrb-goal__amount">${this.formatPrice(amount)}</p><p class="jrb-goal__label">${this.escapeHtml(tier.label || '')}</p><p class="jrb-goal__message">${this.escapeHtml(message)}</p></div></div>`;
      }).join('');

      this.updateProgressMeter();
      this.previousSubtotal = subtotal;
    }

    async renderCurrentStep() {
      const step = this.config.steps[this.currentStepIndex];
      if (!step) return;

      const requestId = ++this.renderRequestId;
      this.body.innerHTML = `<div class="jrb-loading">Loading ${this.escapeHtml(step.title)}…</div>`;
      this.updateFooter();
      this.scrollStepToTop();

      try {
        let content = '';
        if (step.key === 'shell') content = await this.renderShellStep(step);
        else if (step.key === 'brands') content = this.renderBrandStep(step);
        else if (step.key === 'grills') content = await this.renderProductFilterStep(step, 'grills', this.config.grillTag);
        else if (step.key === 'keychains') content = await this.renderProductFilterStep(step, 'keychains', this.config.keychainTag);
        else if (step.key === 'upsell') content = await this.renderUpsellStep(step);

        if (requestId !== this.renderRequestId) return;
        this.body.innerHTML = content;
        if (this.scrollArea) {
          this.scrollArea.classList.toggle('is-scrollable', step.key === 'brands' || step.key === 'upsell');
        }
        this.root.dataset.jrbStep = step.key;
        this.root.classList.remove('jrb-step--shell', 'jrb-step--brands', 'jrb-step--grills', 'jrb-step--keychains', 'jrb-step--upsell');
        this.root.classList.add(`jrb-step--${step.key}`);
      } catch (error) {
        if (requestId !== this.renderRequestId) return;
        console.error('Jack Rack Builder step render failed', error);
        this.body.innerHTML = `<div class="jrb-error">Something broke while loading this step. Try again.</div>`;
      }

      if (requestId !== this.renderRequestId) return;
      this.updateCardSelectionState();
      this.updateFooter();
      this.updatePreview();
      this.preloadImageSet(this.state.keychains.map((entry) => this.getSizedImage(entry?.image, 220)));
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
      this.scrollStepToTop();
      this.updateFooterHeightVar();
    }

    async renderShellStep(step) {
      const handle = this.config.shellCollection;
      const intro = this.renderStepIntro(step);

      if (!handle) return `${intro}<div class="jrb-empty">Pick a shell collection in the section settings first.</div>`;

      const products = await this.fetchCollectionProducts(handle);
      if (!products.length) return `${intro}<div class="jrb-empty">No shell products found in that collection.</div>`;

      this._currentStepProducts = products;
      return `${intro}${this.renderCarousel(products, 'shell', false)}${this.renderProductGrid(products, 'shell')}`;
    }

    renderBrandStep(step) {
      const intro = this.renderStepIntro(step);
      const brands = Array.isArray(this.config.brands) ? this.config.brands.filter((item) => item && item.handle) : [];
      if (!brands.length) return `${intro}<div class="jrb-empty">Add band or brand collection blocks in the section settings to populate this step.</div>`;
      return `${intro}<div class="jrb-grid" style="--jrb-cols:${this.getStepColumns('brands')}">${brands.map((brand) => this.renderBrandCard(brand)).join('')}</div>`;
    }

    async renderProductFilterStep(step, stateKey, tag) {
      const intro = this.renderStepIntro(step);

      if (!this.state.brands.length) {
        return `${intro}<div class="jrb-empty">Pick at least one band or brand first.</div>`;
      }

      const selectedProducts = await this.fetchTaggedProductsFromSelectedCollections(tag);
      const allProducts = await this.fetchTaggedProductsFromAllCollections(tag);
      const selectedIds = new Set(selectedProducts.map((product) => String(product.id)));

      const combined = [
        ...selectedProducts,
        ...allProducts.filter((product) => !selectedIds.has(String(product.id)))
      ];

      this._currentStepProducts = combined;

      if (!combined.length) {
        const safeTag = this.escapeHtml(tag || 'matching');
        return `${intro}<div class="jrb-empty">No products tagged <strong>${safeTag}</strong> were found.</div>`;
      }

      return `
        ${intro}
        ${this.renderCarousel(combined, stateKey, false)}
      `;
    }

    async renderUpsellStep(step) {
      const intro = this.renderStepIntro(step);
      const upsellCollections = this.getUpsellCollections();

      if (upsellCollections.length) {
        if (!this.activeUpsellCollectionHandle) {
          this._currentStepProducts = [];
          return `${intro}${this.renderUpsellCollectionsView()}`;
        }

        const activeMeta = this.getActiveUpsellCollectionMeta();
        if (!activeMeta) {
          this.activeUpsellCollectionHandle = null;
          this._currentStepProducts = [];
          return `${intro}${this.renderUpsellCollectionsView()}`;
        }

        const products = await this.fetchCollectionProducts(activeMeta.handle);
        this._currentStepProducts = products;

        if (!products.length) {
          return `${intro}${this.renderUpsellCollectionToolbar(activeMeta)}<div class="jrb-empty">No products were found in that upsell collection.</div>`;
        }

        return `${intro}${this.renderUpsellCollectionToolbar(activeMeta)}${this.renderProductGrid(products, 'upsell')}`;
      }

      let products = [];
      if (this.config.upsellCollection) {
        products = await this.fetchCollectionProducts(this.config.upsellCollection);
      } else if (this.config.upsellProductHandle) {
        const singleProduct = await this.fetchProductByHandle(this.config.upsellProductHandle);
        products = singleProduct ? [singleProduct] : [];
      }

      this._currentStepProducts = products;

      if (!products.length) {
        return `${intro}<div class="jrb-empty">Pick an upsell collection or a featured product in the section settings first.</div>`;
      }

      return `${intro}${this.renderProductGrid(products, 'upsell')}`;
    }

    renderStepIntro(step) {
      const description = step.description ? `<p>${this.escapeHtml(step.description)}</p>` : '';
      return `<div class="jrb-step-head"><h3>${this.escapeHtml(step.title)}</h3>${description}</div>`;
    }

    renderBrandCard(brand) {
      const selected = this.state.brands.includes(brand.handle);
      return `<div class="jrb-card ${selected ? 'is-selected' : ''}" data-jrb-card data-jrb-type="brands" data-jrb-id="${this.escapeAttribute(brand.handle)}" role="button" tabindex="0" aria-label="${this.escapeAttribute(brand.title)}">
        <div class="jrb-card__image-wrap">
          <img class="jrb-card__image" src="${this.escapeAttribute(brand.image || PLACEHOLDER_IMAGE)}" alt="${this.escapeAttribute(brand.title)}" loading="lazy">
        </div>
      </div>`;
    }

    renderProductCard(product, stateKey) {
      const selectedEntry = this.state[stateKey].find((item) => String(item.id) === String(product.id));
      const selected = Boolean(selectedEntry);
      const isKeychain = stateKey === 'keychains';
      const isUpsell = stateKey === 'upsell';
      const allVariants = Array.isArray(product?.variants) ? product.variants : [];
      const availableVariants = allVariants.filter((variant) => Boolean(variant?.available));
      const variants = allVariants.length ? allVariants : availableVariants;
      const hasVariantChoices = variants.length > 1;
      const selectedVariantId = String(selectedEntry?.variantId || availableVariants[0]?.id || variants[0]?.id || '');
      const qty = Number(selectedEntry?.quantity || 1);

      const variantHtml = hasVariantChoices
        ? `<div class="jrb-variant-wrap" ${selected ? '' : 'hidden'}>
            <div class="jrb-variant-bubbles" role="group" aria-label="Choose variant">
              ${variants.map((variant) => {
                const soldOut = !Boolean(variant?.available);
                return `<button type="button" class="jrb-variant-bubble ${String(variant.id) === selectedVariantId ? 'is-active' : ''} ${soldOut ? 'is-sold-out' : ''}" data-jrb-variant-bubble data-jrb-variant-product="${product.id}" data-jrb-state-key="${stateKey}" data-jrb-variant-id="${this.escapeAttribute(String(variant.id))}" ${soldOut ? 'disabled aria-disabled="true"' : ''}>${this.escapeHtml(variant.title || 'Variant')}</button>`;
              }).join('')}
            </div>
          </div>`
        : '';

      const qtyHtml = (isKeychain || isUpsell)
        ? `
          <div class="jrb-qty-inline" ${selected ? '' : 'hidden'}>
            <button type="button" class="jrb-qty-inline__button" data-jrb-qty-button="${product.id}" data-jrb-state-key="${stateKey}" data-delta="-1" aria-label="Decrease quantity">−</button>
            <input class="jrb-qty-inline__input" type="number" min="1" value="${qty}" data-jrb-qty-input="${product.id}" data-jrb-state-key="${stateKey}" aria-label="Quantity">
            <button type="button" class="jrb-qty-inline__button" data-jrb-qty-button="${product.id}" data-jrb-state-key="${stateKey}" data-delta="1" aria-label="Increase quantity">+</button>
          </div>
        `
        : '';

      const footerClasses = [
        isKeychain ? 'jrb-card__footer--keychain' : '',
        isUpsell ? 'jrb-card__footer--upsell' : '',
        (!isUpsell && hasVariantChoices) ? 'jrb-card__footer--stacked' : ''
      ].filter(Boolean).join(' ');

      const hideChip = selected && (isKeychain || isUpsell || hasVariantChoices);

      return `<div class="jrb-card ${selected ? 'is-selected' : ''}" data-jrb-card data-jrb-type="${this.escapeAttribute(stateKey)}" data-jrb-id="${this.escapeAttribute(String(product.id))}" role="button" tabindex="0">
        <span class="jrb-badge">Selected</span>
        <div class="jrb-card__image-wrap"><img class="jrb-card__image" src="${this.escapeAttribute(this.getProductImage(product))}" alt="${this.escapeAttribute(product.title || 'Product')}" loading="lazy"></div>
        <div class="jrb-card__body">
          <h4 class="jrb-card__title">${this.escapeHtml(product.title || 'Untitled product')}</h4>
          <p class="jrb-card__meta">${this.getDisplayPriceHtml(product, stateKey)}</p>
        </div>
        <div class="jrb-card__footer ${footerClasses}">
          ${variantHtml}
          ${qtyHtml}
          <span class="jrb-chip" ${hideChip ? 'hidden' : ''}>${selected ? 'Selected' : 'Select'}</span>
        </div>
      </div>`;
    }

    async fetchCollectionProducts(handle) {
      if (!handle) return [];
      if (this.collectionCache.has(handle)) return this.collectionCache.get(handle);

      const endpoint = `${window.Shopify?.routes?.root || '/'}collections/${encodeURIComponent(handle)}/products.json?limit=250`;
      const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Collection request failed for ${handle}`);

      const data = await response.json();
      const products = (Array.isArray(data.products) ? data.products : []).filter((product) => this.productIsAvailable(product));
      this.collectionCache.set(handle, products);
      return products;
    }

    async fetchProductByHandle(handle) {
      if (!handle) return null;
      const cacheKey = `product:${handle}`;
      if (this.collectionCache.has(cacheKey)) return this.collectionCache.get(cacheKey);

      const endpoint = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`;
      const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Product request failed for ${handle}`);

      const product = await response.json();
      this.collectionCache.set(cacheKey, product || null);
      return product || null;
    }

    async fetchTaggedProductsFromSelectedCollections(tag) {
      const normalizedTag = (tag || '').trim().toLowerCase();
      const results = await Promise.all([...this.state.brands].map((handle) => this.fetchCollectionProducts(handle)));
      const deduped = new Map();

      results.flat().forEach((product) => {
        if (!product || !product.id) return;
        if (normalizedTag && !this.productHasTag(product, normalizedTag)) return;
        if (!deduped.has(String(product.id))) deduped.set(String(product.id), product);
      });

      return Array.from(deduped.values());
    }

    productIsAvailable(product) {
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      if (!variants.length) return false;
      return variants.some((variant) => Boolean(variant?.available));
    }

    productHasTag(product, normalizedTag) {
      const tags = product.tags;
      if (!normalizedTag) return true;
      if (Array.isArray(tags)) return tags.some((tag) => String(tag).trim().toLowerCase() === normalizedTag);
      if (typeof tags === 'string') return tags.split(',').map((tag) => tag.trim().toLowerCase()).includes(normalizedTag);
      return false;
    }

    getProductImage(product) {
      if (product?.images?.[0]?.src) return product.images[0].src;
      if (product?.image?.src) return product.image.src;
      return PLACEHOLDER_IMAGE;
    }

    getProductPriceCents(product, variantId = null) {
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      const matchedVariant = variantId
        ? variants.find((variant) => String(variant?.id) === String(variantId))
        : null;
      const firstAvailableVariant = variants.find((variant) => Boolean(variant?.available));
      const firstVariant = matchedVariant || firstAvailableVariant || variants[0] || null;
      const variantPrice = firstVariant?.price;

      if (typeof variantPrice === 'number') return Math.round(variantPrice);
      if (typeof variantPrice === 'string') return Math.round(parseFloat(variantPrice) * 100);

      const productPrice = product?.price;
      if (typeof productPrice === 'number') return Math.round(productPrice);
      if (typeof productPrice === 'string') {
        const parsed = parseFloat(productPrice);
        if (!Number.isNaN(parsed)) return productPrice.includes('.') ? Math.round(parsed * 100) : Math.round(parsed);
      }

      return 0;
    }

    formatPrice(cents) {
      const amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: this.config.currencyCode || 'USD'
        }).format(amount);
      } catch (error) {
        return `$${amount.toFixed(2)}`;
      }
    }

    toggleSelection(card) {
      const type = card.dataset.jrbType;
      const id = card.dataset.jrbId;
      if (!type || !id) return;

      if (type === 'brands') {
        const next = [...this.state.brands];
        const existingIndex = next.indexOf(id);

        if (existingIndex > -1) {
          next.splice(existingIndex, 1);
        } else {
          const max = Number(this.config.brandMax || 999);
          if (next.length >= max) return;
          next.push(id);
        }

        const changed = JSON.stringify(next) !== JSON.stringify(this.state.brands);
        this.state.brands = next;

        if (changed) {
          this.state.grills = [];
          this.state.keychains = [];
          this.activePreview.grillId = null;
        }
      } else {
        const collection = this.getCurrentStepProducts();
        const product = collection.find((item) => String(item.id) === id);
        if (!product) return;

        const max = Number(this.getCurrentStepConfig().max || 999);
        const next = [...this.state[type]];
        const existingIndex = next.findIndex((item) => String(item.id) === String(product.id));

        if (existingIndex > -1) {
          next.splice(existingIndex, 1);
        } else {
          const normalized = this.normalizeProductSelection(product, 1);
          if (next.length >= max) return;
          next.push(normalized);
          if (type === 'shell') this.activePreview.shellId = String(product.id);
          if (type === 'grills') this.activePreview.grillId = String(product.id);
        }

        this.state[type] = next;

        if (type === 'keychains') {
          const flattenedKeyCount = this.getTotalKeyQuantity();
          this.previewKeyStartIndex = Math.max(0, flattenedKeyCount - 4);
        }

        if (type === 'shell' && !this.state.shell.some((item) => String(item.id) === String(this.activePreview.shellId))) {
          this.activePreview.shellId = this.state.shell[0] ? String(this.state.shell[0].id) : null;
        }

        if (type === 'grills' && !this.state.grills.some((item) => String(item.id) === String(this.activePreview.grillId))) {
          this.activePreview.grillId = this.state.grills[0] ? String(this.state.grills[0].id) : null;
        }
      }

      this.updateCardSelectionState();
      this.updateFooter();
      this.updatePreview();
      this.preloadImageSet(this.state.keychains.map((entry) => this.getSizedImage(entry?.image, 220)));
const totalKeys = this.getTotalKeyQuantity();
const leftBtn = this.root.querySelector('[data-jrb-preview-left]');
const rightBtn = this.root.querySelector('[data-jrb-preview-right]');
if (leftBtn && rightBtn) {
  if (totalKeys > 4) {
    leftBtn.hidden = this.previewKeyStartIndex === 0;
    rightBtn.hidden = this.previewKeyStartIndex >= totalKeys - 4;
  } else {
    leftBtn.hidden = true;
    rightBtn.hidden = true;
  }
}
    }

    normalizeProductSelection(product, quantity = 1) {
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      const firstVariant = variants.find((variant) => Boolean(variant?.available)) || variants[0] || null;
      return {
        id: String(product.id),
        variantId: firstVariant?.id ? String(firstVariant.id) : null,
        title: product.title || '',
        price: this.getProductPriceCents(product, firstVariant?.id ? String(firstVariant.id) : null),
        image: this.getProductImage(product),
        quantity
      };
    }

    getCurrentStepConfig() {
      return this.config.steps[this.currentStepIndex];
    }

    getCurrentStepProducts() {
      const step = this.getCurrentStepConfig();
      if (!step) return [];
      if (step.key === 'shell') return this.collectionCache.get(this.config.shellCollection) || [];
      if (step.key === 'grills' || step.key === 'keychains' || step.key === 'upsell') return Array.from(this._currentStepProducts || []);
      return [];
    }

    getStepColumns(key) {
      const value = Number(this.config.columns?.[key] || 4);
      return Math.min(Math.max(value, 2), 6);
    }

    async goNext() {
      if (this.loading) return;

      if (!this.isCurrentStepValid()) return;

      if (this.currentStepIndex === this.config.steps.length - 1) {
        await this.addBundleToCart();
        return;
      }

      this.currentStepIndex += 1;
      await this.renderCurrentStep();
    }

    async goPrevious() {
      if (this.currentStepIndex === 0 || this.loading) return;
      this.currentStepIndex -= 1;
      await this.renderCurrentStep();
    }

    isCurrentStepValid() {
      const step = this.getCurrentStepConfig();
      if (!step) return false;
      const count = step.key === 'brands' ? this.state.brands.length : this.state[step.key].length;
      const min = Number(step.min || 0);
      const max = Number(step.max || 999);
      return count >= min && count <= max;
    }

    updateCardSelectionState() {
      this.body.querySelectorAll('[data-jrb-card]').forEach((card) => {
        const type = card.dataset.jrbType;
        const id = card.dataset.jrbId;
        let selected = false;
        let quantity = 1;
        let selectedItem = null;

        if (type === 'brands') {
          selected = this.state.brands.includes(id);
        } else {
          selectedItem = this.state[type].find((item) => String(item.id) === String(id));
          selected = Boolean(selectedItem);
          quantity = Number(selectedItem?.quantity || 1);
        }

        card.classList.toggle('is-selected', selected);

        const chip = card.querySelector('.jrb-chip');
        if (chip) chip.textContent = selected ? 'Selected' : 'Select';

        const qtyWrap = card.querySelector('.jrb-qty-inline');
        if (qtyWrap) qtyWrap.hidden = !selected;

        const qtyInput = card.querySelector('[data-jrb-qty-input]');
        if (qtyInput) qtyInput.value = quantity;

        const variantWrap = card.querySelector('.jrb-variant-wrap');
        if (variantWrap) {
          variantWrap.hidden = !selected;
        }

        card.querySelectorAll('[data-jrb-variant-bubble]').forEach((bubble) => {
          const bubbleVariantId = String(bubble.dataset.jrbVariantId || '');
          bubble.classList.toggle('is-active', Boolean(selectedItem?.variantId) && bubbleVariantId === String(selectedItem.variantId));
        });

        const hasInteractiveFooter = Boolean(qtyWrap || variantWrap);
        if (chip) chip.hidden = selected && hasInteractiveFooter;
      });
    }

    async addBundleToCart() {
      const selections = [...this.state.shell, ...this.state.grills, ...this.state.keychains, ...this.state.upsell]
        .filter((item) => item && item.variantId)
        .map((item) => ({ id: String(item.variantId), quantity: Number(item.quantity || 1) }));

      if (!selections.length) return;

      this.loading = true;
      this.nextButton.disabled = true;
      this.nextButton.textContent = 'Adding…';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: selections })
        });

        if (!response.ok) {
          let message = 'Could not add bundle to cart.';
          try {
            const err = await response.json();
            if (err?.description) message = err.description;
          } catch (_) {}
          throw new Error(message);
        }

        const upsellDiscountCode = this.getApplicableUpsellDiscountCode();
        if (upsellDiscountCode) {
          window.location.href = `${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(upsellDiscountCode)}?redirect=/cart`;
        } else {
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        }
      } catch (error) {
        console.error('Jack Rack Builder cart add failed', error);

        try {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = `${window.Shopify?.routes?.root || '/'}cart/add`;

          selections.forEach((item, index) => {
            const idInput = document.createElement('input');
            idInput.type = 'hidden';
            idInput.name = `items[${index}][id]`;
            idInput.value = String(item.id);
            form.appendChild(idInput);

            const qtyInput = document.createElement('input');
            qtyInput.type = 'hidden';
            qtyInput.name = `items[${index}][quantity]`;
            qtyInput.value = String(item.quantity);
            form.appendChild(qtyInput);
          });

          document.body.appendChild(form);
          form.submit();
          return;
        } catch (_) {}

        this.nextButton.disabled = false;
        this.nextButton.textContent = this.config.addLabel;

        const existing = this.body.querySelector('.jrb-error');
        if (!existing) {
          this.body.insertAdjacentHTML(
            'afterbegin',
            `<div class="jrb-error">${this.escapeHtml(error?.message || 'Could not add the bundle to cart. Please try again.')}</div>`
          );
        }
      } finally {
        this.loading = false;
      }
    }

    escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    escapeAttribute(value) {
      return this.escapeHtml(value).replace(/`/g, '&#096;');
    }
  }

  function initJackRackBuilders(scope = document) {
    scope.querySelectorAll('.jrb-launcher').forEach((root) => {
      if (root.dataset.jrbReady === 'true') return;
      root.dataset.jrbReady = 'true';
      new JackRackBuilder(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initJackRackBuilders());
  document.addEventListener('shopify:section:load', (event) => initJackRackBuilders(event.target));
})();